import React from 'react';
import type { OrgChartPerson, OrgDepartment, OrgLevel } from '../../../types/purchasing';
import type { ReportingSyncRow } from '../../../utils/orgReporting';

export type OrgChartEditApi = {
  canEdit: boolean;
  savingUid: string | null;
  managerOptions: OrgChartPerson[];
  /** Stored manager differs from the rule-derived manager for these people. */
  outOfSyncUids: Set<string>;
  syncDiff: ReportingSyncRow[];
  onChangeManager: (person: OrgChartPerson, next: string) => void;
  onChangePlacement: (
    person: OrgChartPerson,
    next: { orgLevel: OrgLevel; orgDepartment: OrgDepartment },
  ) => void;
  onApplyRules: () => void;
};

export const OrgChartEditContext = React.createContext<OrgChartEditApi>({
  canEdit: false,
  savingUid: null,
  managerOptions: [],
  outOfSyncUids: new Set(),
  syncDiff: [],
  onChangeManager: () => undefined,
  onChangePlacement: () => undefined,
  onApplyRules: () => undefined,
});
